export default __webpack_public_path__ + "static/media/IMG_1998.e73ff0c7.JPG";